import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";
import ProductForm from "@/components/products/product-create-update/product-form";

export const Route = createFileRoute("/_authenticated/products/_layout/new")({
  component: NewProductPage,
});

function NewProductPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "products", actions: ["create"] }]}
    >
      <ProductForm />
    </RouteGuardPermissions>
  );
}
